import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import ReactPixel from 'react-facebook-pixel';
import { trackInitiateCheckout } from '../App';
// ── EDITAR ESTE NÚMERO MANUALMENTE CUANDO ALGUIEN COMPRE ──
const CUPOS_TOTAL = 20;
const CUPOS_TOMADOS = 14; // ← cambiá este número cada vez que entra alguien
// ─────────────────────────────────────────────────────────
function useCountdown(hours: number = 24) {
  const key = 'dm_countdown_end';
  const getEnd = () => {
    const stored = localStorage.getItem(key);
    if (stored) return parseInt(stored);
    const end = Date.now() + hours * 60 * 60 * 1000;
    localStorage.setItem(key, String(end));
    return end;
  };
  const calc = (end: number) => {
    const diff = Math.max(0, end - Date.now());
    return {
      h: Math.floor(diff / 3600000),
      m: Math.floor(diff % 3600000 / 60000),
      s: Math.floor(diff % 60000 / 1000)
    };
  };
  const [end] = useState(getEnd);
  const [time, setTime] = useState(() => calc(end));
  useEffect(() => {
    const id = setInterval(() => setTime(calc(end)), 1000);
    return () => clearInterval(id);
  }, [end]);
  return time;
}
function Digit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  const str = String(value).padStart(2, '0');
  return <div className="flex flex-col items-center" data-id="element-236">
      <div className="bg-[#111] border border-[#C9A84C]/30 rounded px-3 py-2 min-w-[52px] text-center" data-id="element-237">
        <span className="font-['Bebas_Neue'] text-3xl text-white leading-none tabular-nums" data-id="element-238">
          {str}
        </span>
      </div>
      <span className="text-[9px] text-gray-600 uppercase tracking-widest mt-1" data-id="element-239">
        {label}
      </span>
    </div>;
}
export function PriceSection() {
  const {
    h,
    m,
    s
  } = useCountdown(24);
  const cuposLibres = CUPOS_TOTAL - CUPOS_TOMADOS;
  const porcentaje = CUPOS_TOMADOS / CUPOS_TOTAL * 100;
  return <section id="precio" className="py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-240">
      {/* Glow effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-[#C9A84C]/10 rounded-full blur-[120px]" data-id="element-241" />

      <div className="container mx-auto px-4 relative z-10 text-center" data-id="element-242">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-xl mx-auto border border-[#C9A84C] bg-[#0a0a0a]/80 backdrop-blur-sm p-12 relative" data-id="element-243">
          {/* Corner decorations */}
          <div className="absolute top-0 left-0 w-6 h-6 border-t-2 border-l-2 border-[#C9A84C]" data-id="element-244" />
          <div className="absolute top-0 right-0 w-6 h-6 border-t-2 border-r-2 border-[#C9A84C]" data-id="element-245" />
          <div className="absolute bottom-0 left-0 w-6 h-6 border-b-2 border-l-2 border-[#C9A84C]" data-id="element-246" />
          <div className="absolute bottom-0 right-0 w-6 h-6 border-b-2 border-r-2 border-[#C9A84C]" data-id="element-247" />

          <span className="inline-block py-1 px-3 bg-[#C9A84C]/20 text-[#C9A84C] text-sm font-bold tracking-widest mb-8 rounded-sm" data-id="element-248">
            INVERSIÓN HOY
          </span>

          {/* Start date */}
          <div className="flex items-center justify-center gap-2 mb-4" data-id="element-249">
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-[#C9A84C] shrink-0" data-id="element-250">
              <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" data-id="element-251" />
            </svg>
            <p className="text-sm text-white font-semibold tracking-wide" data-id="element-252">
              Inicio:{' '}
              <span className="text-[#C9A84C]" data-id="element-253">
                cuando se completen los cupos
              </span>
            </p>
          </div>

          {/* ── CONTADOR DE CUPOS ── */}
          <div className="mb-6 bg-[#111] border border-white/5 rounded-sm p-4" data-id="element-254">
            {/* Header row */}
            <div className="flex items-center justify-between mb-3" data-id="element-255">
              <div className="flex items-center gap-2" data-id="element-256">
                <span className="relative flex h-2 w-2 shrink-0" data-id="element-257">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-258" />
                  <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-259" />
                </span>
                <span className="text-red-400 text-xs font-bold uppercase tracking-widest" data-id="element-260">
                  Cupos disponibles
                </span>
              </div>
              <span className="font-['Bebas_Neue'] text-lg text-white" data-id="element-261">
                <span className="text-[#C9A84C]" data-id="element-262">{cuposLibres}</span>
                <span className="text-gray-600" data-id="element-263"> / {CUPOS_TOTAL}</span>
              </span>
            </div>

            {/* Progress bar */}
            <div className="w-full h-2 bg-[#1a1a1a] rounded-full overflow-hidden" data-id="element-264">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: `${porcentaje}%`
            }} viewport={{
              once: true
            }} transition={{
              duration: 1.2,
              ease: 'easeOut',
              delay: 0.3
            }} className="h-full bg-gradient-to-r from-[#C9A84C] to-[#e8c96a] rounded-full" data-id="element-265" />
            </div>

            {/* Slots visual */}
            <div className="flex items-center gap-1 mt-3 justify-center flex-wrap" data-id="element-266">
              {Array.from({
              length: CUPOS_TOTAL
            }).map((_, i) => <div key={i} className={`w-5 h-5 rounded-sm text-[9px] font-bold flex items-center justify-center ${i < CUPOS_TOMADOS ? 'bg-[#C9A84C]/20 border border-[#C9A84C]/40 text-[#C9A84C]' : 'bg-[#1a1a1a] border border-white/5 text-gray-700'}`} data-id="element-267">
                  {i < CUPOS_TOMADOS ? '✓' : ''}
                </div>)}
            </div>
            <p className="text-gray-600 text-[10px] mt-2 uppercase tracking-widest" data-id="element-268">
              {CUPOS_TOMADOS} personas ya reservaron su lugar
            </p>
          </div>
          {/* ── FIN CONTADOR ── */}

          {/* Countdown */}
          <div className="mb-8" data-id="element-269">
            <p className="text-[10px] text-gray-500 uppercase tracking-[0.2em] mb-3" data-id="element-270">
              Precio especial termina en
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-271">
              <Digit value={h} label="horas" data-id="element-272" />
              <span className="font-['Bebas_Neue'] text-2xl text-[#C9A84C] mb-4" data-id="element-273">
                :
              </span>
              <Digit value={m} label="min" data-id="element-274" />
              <span className="font-['Bebas_Neue'] text-2xl text-[#C9A84C] mb-4" data-id="element-275">
                :
              </span>
              <Digit value={s} label="seg" data-id="element-276" />
            </div>
          </div>

          <div className="mb-8" data-id="element-277">
            <div className="flex items-center justify-center gap-2 mb-3" data-id="element-278">
              <span className="text-xs text-gray-500 uppercase tracking-widest" data-id="element-279">
                Valor real del programa:
              </span>
              <span className="text-sm text-gray-400 line-through font-['Bebas_Neue']" data-id="element-280">
                $80.000
              </span>
            </div>
            <motion.p animate={{
            scale: [1, 1.05, 1]
          }} transition={{
            duration: 2,
            repeat: Infinity
          }} className="text-7xl md:text-8xl font-['Bebas_Neue'] text-white leading-none" data-id="element-281">
              $19.000
            </motion.p>
            <p className="text-[#C9A84C] text-xs font-bold uppercase tracking-widest mt-2" data-id="element-282">
              Precio de lanzamiento — ahorrás $61.000
            </p>
          </div>

          <Button size="lg" className="w-full text-lg mb-3" onClick={() => {
          trackInitiateCheckout();
          window.open('https://pzhbwp-zj.myshopify.com/cart/43946659938439:1', '_blank');
        }} data-id="element-283">
            RESERVAR MI LUGAR
          </Button>

          <div className="flex items-center justify-center gap-2.5 mb-4 bg-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm px-4 py-3" data-id="element-284">
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 text-[#C9A84C] shrink-0" data-id="element-285">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" data-id="element-286" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" data-id="element-287" />
            </svg>
            <p className="text-xs text-[#C9A84C] font-medium" data-id="element-288">
              Al pagar, el link del grupo de WhatsApp llega{' '}
              <span className="font-bold" data-id="element-289">inmediatamente</span> a tu Gmail.
            </p>
          </div>

          <p className="text-sm text-gray-500 mb-8" data-id="element-290">
            Cupos limitados. No es para todos.
          </p>

          <div className="border-t border-white/5 pt-6" data-id="element-291">
            <p className="text-xs text-gray-600 uppercase tracking-[0.15em] mb-4" data-id="element-292">
              Medios de pago aceptados
            </p>
            <div className="flex items-center justify-center gap-3 mb-4 flex-wrap" data-id="element-293">
              <div className="bg-[#1a1a1a] border border-white/10 rounded px-3 py-1.5 flex items-center gap-1.5" data-id="element-294">
                <svg viewBox="0 0 48 16" className="h-4 w-auto" fill="none" data-id="element-295">
                  <text x="0" y="13" fontSize="14" fontWeight="bold" fill="#1A1F71" fontFamily="Arial" data-id="element-296">
                    VISA
                  </text>
                </svg>
                <span className="text-[10px] text-gray-500 font-medium" data-id="element-297">
                  Visa
                </span>
              </div>
              <div className="bg-[#1a1a1a] border border-white/10 rounded px-3 py-1.5 flex items-center gap-1.5" data-id="element-298">
                <div className="flex items-center" data-id="element-299">
                  <div className="w-4 h-4 rounded-full bg-[#EB001B] opacity-90" data-id="element-300" />
                  <div className="w-4 h-4 rounded-full bg-[#F79E1B] opacity-90 -ml-2" data-id="element-301" />
                </div>
                <span className="text-[10px] text-gray-500 font-medium" data-id="element-302">
                  Mastercard
                </span>
              </div>
              <div className="bg-[#1a1a1a] border border-white/10 rounded px-3 py-1.5 flex items-center gap-1.5" data-id="element-303">
                <div className="w-4 h-4 rounded-full bg-[#009EE3] flex items-center justify-center" data-id="element-304">
                  <span className="text-white text-[8px] font-black" data-id="element-305">MP</span>
                </div>
                <span className="text-[10px] text-gray-500 font-medium" data-id="element-306">
                  Mercado Pago
                </span>
              </div>
              <div className="bg-[#1a1a1a] border border-white/10 rounded px-3 py-1.5 flex items-center gap-1.5" data-id="element-307">
                <svg viewBox="0 0 16 16" className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="1.5" data-id="element-308">
                  <path d="M2 8h12M10 4l4 4-4 4" strokeLinecap="round" strokeLinejoin="round" data-id="element-309" />
                </svg>
                <span className="text-[10px] text-gray-500 font-medium" data-id="element-310">
                  Transferencia
                </span>
              </div>
            </div>
            <div className="flex items-center justify-center gap-2" data-id="element-311">
              <div className="flex items-center gap-2 bg-[#C9A84C]/10 border border-[#C9A84C]/30 rounded-sm px-4 py-2" data-id="element-312">
                <svg viewBox="0 0 20 20" className="w-4 h-4 text-[#C9A84C]" fill="currentColor" data-id="element-313">
                  <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" data-id="element-314" />
                </svg>
                <span className="text-[#C9A84C] text-xs font-bold tracking-wide" data-id="element-315">
                  Hasta 3 cuotas sin interés
                </span>
              </div>
            </div>
            <div className="flex items-center justify-center gap-1.5 mt-3" data-id="element-316">
              <svg viewBox="0 0 16 16" className="w-3 h-3 text-gray-600" fill="currentColor" data-id="element-317">
                <path fillRule="evenodd" d="M8 1l6 2.5v4c0 3.5-2.5 6.5-6 7.5C2.5 13 0 10 0 6.5v-4L8 1zm0 2.2L2 5.3v3.2C2 11 4.5 13.3 8 14.2c3.5-.9 6-3.2 6-5.7V5.3L8 3.2zm3 3.3l-3.5 3.5-1.5-1.5-.7.7 2.2 2.2 4.2-4.2-.7-.7z" clipRule="evenodd" data-id="element-318" />
              </svg>
              <span className="text-[10px] text-gray-600 tracking-wide" data-id="element-319">
                Pago 100% seguro y encriptado
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}